import React, { createContext, useContext, useState } from "react";

// Create the context with a default value
const ModalContext = createContext(null);

export const ModalProvider = ({ children }) => {
	const [isLoginModalOpen, setLoginModalOpen] = useState(false);
	const [isSignUpModalOpen, setSignUpModalOpen] = useState(false);
	const [isPlanModalOpen, setPlanModalOpen] = useState(false);

	const openLoginModal = () => {
		setSignUpModalOpen(false);
		setPlanModalOpen(false);
		setLoginModalOpen(true);
	};
	const closeLoginModal = () => setLoginModalOpen(false);

	const openSignUpModal = () => {
		setLoginModalOpen(false);
		setPlanModalOpen(false);
		setSignUpModalOpen(true);
	};
	const closeSignUpModal = () => setSignUpModalOpen(false);

	const openPlanModal = () => {
		setLoginModalOpen(false);
		setSignUpModalOpen(false);
		setPlanModalOpen(true);
	};
	const closePlanModal = () => setPlanModalOpen(false);

	const handleOverlayClick = (e, closeFn) => {
		if (e.target.className === "modal-overlay" || e.target.className === "plan-button") {
			closeFn();
		}
	};

	return (
		<ModalContext.Provider
			value={{
				isLoginModalOpen,
				isSignUpModalOpen,
				isPlanModalOpen,
				openLoginModal,
				closeLoginModal,
				openSignUpModal,
				closeSignUpModal,
				openPlanModal,
				closePlanModal,
				handleOverlayClick,
			}}>
			{children}
		</ModalContext.Provider>
	);
};

export const useModal = () => {
	const context = useContext(ModalContext);
	if (!context) {
		throw new Error("useModal must be used within a ModalProvider");
	}
	return context;
};
